let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ciFl0")).then(() => parcelRequire('kiRNZ'));